<template>
<div class="content">
                <FlashMessage :position="'right top'"></FlashMessage>

    <!-- <transition name="fade" mode="out-in"> -->
    <!-- your content here -->
    <!-- <router-view>
      </router-view> -->
    <h1>Dashboard </h1>
    <!-- </transition> -->
</div>
</template>

<script>
export default {}
</script>
<!-- 
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .15s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */

    {
    opacity: 0
}
</style> -->
